import Divider from '@material-ui/core/Divider';
import { styled } from '@material-ui/core/styles';

export const FeedbackContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center'
});

export const DetailsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.5, 3)
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0)
}));

export const CommentsContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3)
}));
